import { useQuery } from '@tanstack/react-query';
import { getCurrencyOptions } from '@/helpers/formatHelpers';
import { loadCurrencies } from '@/bundle/_OrgAdmin/pages/TransactionDetailsPage/api/api';

export const useGetCurrencyOptions = (enabled: boolean) => {
  const { data: currencies } = useQuery({
    queryKey: ['load_currencies'],
    queryFn: () => loadCurrencies(),
    enabled,
  });

  const currencyOptions = getCurrencyOptions(currencies?.body?.results);

  return {
    currencyOptions,
  };
};
